"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, { UiFormAnnotations, UiFormController } from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import i18n from "@/lang";
import PasswordInput from "@/views/accountItems/components/PasswordInput.vue";
export class DeleteVdForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.security_code = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("deletevddialog.security_opcode_cannot_be_empty"),
    trigger: "blur"
  }])
], DeleteVdForm.prototype, "security_code", 2);
let DeleteVdDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.rows = [];
    this.dialogLoading = false;
    this.dialog = new UiDialogController();
    this.controller = new DeleteVdForm();
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  submit() {
    return __async(this, null, function* () {
      try {
        let ids = [];
        for (const item of this.rows) {
          ids.push(item.id);
        }
        yield API.delete(`api://base.auth.pro/v1/virtual-desktops`, {
          data: {
            ids,
            securityCode: this.controller.security_code
          }
        });
        this.$message.success(this.$t("deletevddialog.delete_successful"));
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.close();
      }
    });
  }
  open(rows) {
    this.rows = rows;
    this.controller = new DeleteVdForm();
    this.controller.security_code = "";
    this.dialog.visible = true;
  }
  openAccount() {
    const { href } = this.$router.resolve({ path: "/account?tab=OrgSetting" });
    window.open(href, "_blank");
  }
  close() {
    this.dialog.visible = false;
    this.$emit("refresh");
  }
};
DeleteVdDialog = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      UiDialog,
      PasswordInput
    }
  })
], DeleteVdDialog);
export {
  DeleteVdDialog as default
};
